export default __webpack_public_path__ + "static/Freight-SansBook-dbacbc97daf39fd150248a8b00c41c31.woff";